const contentPrivacy = () => import("@/pages/content/privacy/index.vue");

export default [
    {
        path: "/content/privacy",
        component: contentPrivacy,
        meta: [
            {
                name: "内容管理",
                activeRoute: "/content/manage",
            },
            {
                name: "隐私政策",
                activeRoute: "/content/privacy",
            },
        ],
    },
];
